import "./App.css";
import Layout from "./Layout";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import { useEffect, useState } from "react";
import { AppProvider } from "./Context/AppProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

import ManageDoc from "./pages/admin/ManageDoc";
import QuestionList from "./pages/admin/QuestionList";
import Settings from "./pages/admin/Settings";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import PageNotFound from "./pages/PageNotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import UserChatHistory from "./pages/admin/ChatHistory";
import ManageLessonTable from "./pages/admin/ManageLessonTable";

const API_BASE_URL = `${process.env.REACT_APP_BACKEND_URL}`;

function AppContent() {
  const location = useLocation();
  const [darkMode, setDarkMode] = useState(true); // Default to dark mode
  const [lockLightMode, setLockLightMode] = useState(false);
  const [isLoadingLockSetting, setIsLoadingLockSetting] = useState(true);

  // Check if current route is a user page (not admin)
  const isUserPage = !location.pathname.startsWith("/admin") || location.pathname === "/admin/login";

  // Fetch lock light mode setting
  useEffect(() => {
    const fetchLockSetting = async () => {
      try {
        const response = await axios.post(`${API_BASE_URL}/api/v1/admin/get-settings`);
        const lockValue = response.data?.data?.lockLightMode;
        setLockLightMode(lockValue === true || lockValue === "true" || lockValue === 1);
      } catch (err) {
        console.error("Failed to fetch lock light mode setting:", err);
        // Default to false if fetch fails
        setLockLightMode(false);
      } finally {
        setIsLoadingLockSetting(false);
      }
    };

    fetchLockSetting();
  }, []);

  // Initialize theme from localStorage
  useEffect(() => {
    const theme = localStorage.getItem("theme");
    // If no theme is stored, default to dark mode
    if (theme === null) {
      setDarkMode(true);
      localStorage.setItem("theme", "dark");
    } else {
      setDarkMode(theme === "dark");
    }
  }, []);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [darkMode]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme={darkMode ? "dark" : "light"}
      />  <AppProvider>
      <Routes>
        {/* Routes without layout */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="*" element={<PageNotFound />} />

        {/* Routes with layout */}
        <Route
          path="/"
          element={
            <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={lockLightMode} isUserPage={isUserPage}>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/chat/:sessionId"
          element={
            <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={lockLightMode} isUserPage={isUserPage}>
              <Home />
            </Layout>
          }
        />
        <Route
          path="/admin/docs"
          element={
            <ProtectedRoute>
              <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={false} isUserPage={false}>
                <ManageDoc />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={false} isUserPage={false}>
                <Dashboard />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/questions"
          element={
            <ProtectedRoute>
              <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={false} isUserPage={false}>
                <QuestionList />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute>
              <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={false} isUserPage={false}>
                <Settings />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/chat-history"
          element={
            <ProtectedRoute>
              <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={false} isUserPage={false}>
                <UserChatHistory />
              </Layout>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/lessons"
          element={
            <ProtectedRoute>
              <Layout darkMode={darkMode} setDarkMode={setDarkMode} lockLightMode={false} isUserPage={false}>
                <ManageLessonTable />
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    
      </AppProvider>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
